// googleMapsConfig.ts (or at top of file)
import { Libraries } from "@react-google-maps/api";

export const LIBRARIES: Libraries = ["places"];
